module.exports = __webpack_public_path__ + "media/images/Acuvue_banner_autumn-297d77e130350b12d66b53da3db12cf5.jpg";